const typePage = {
  STATIC: "1",
  MULTI_PAGE: "2",
};

const typePageString = () => {
  let data = {};
  data[typePage.STATIC] = "ثابت";
  data[typePage.MULTI_PAGE] = "چند صفحه ای";

  return data;
};

export default {
  typePage,
  typePageString,
};
